import { Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import CustomTable from './CustomTable';
import District from '../../model/District';
import { grey } from '@mui/material/colors';
import OlympicsContext from '../../store/olympics-context';
import Loader from '../../ui/Loader';

const DistrictsTable = () => {
	const { palette } = useTheme();
	const { districts, isDistrictsLoading } = useContext(OlympicsContext);

	const data = (input: any) => {
		return {
			columns: [
				{ header: 'Identyfikator', accessor: 'id' },
				{ header: 'Nazwa', accessor: 'name', align: 'left', bgColor: grey[100] },
			],

			rows: input
				? input.map((i: District) => {
						return {
							id: (
								<Typography
									variant='caption'
									fontWeight='medium'
								>
									{i.id.toString().padStart(4, '0')}
								</Typography>
							),
							name: (
								<Typography
									variant='caption'
									fontWeight='medium'
								>
									{i.name}
								</Typography>
							),
						};
					})
				: [],
		};
	};

	return (
		<>
			{isDistrictsLoading ? (
				<Loader />
			) : (
				<CustomTable
					data={data(districts)}
					defaultSort={{ accessor: 'name', desc: false }}
				/>
			)}
		</>
	);
};

export default DistrictsTable;
